module.exports = __webpack_public_path__ + "static/media/boda-logo1.60905962.png";